module.exports = __webpack_public_path__ + "static/media/Desktop_Purpose_31.cd168b79.png";